// @flow
import React from 'react'
import PRHeaderBottom from './PRHeaderBottom'
import PRHeaderTop from '../../../containers/pull_request/Header/PRHeaderTopContainer'
import FlashMessageList from './../../shared/flashMessages/FlashMessageList'

type Props = {
  model: Object,
}

export default class HeaderPR extends React.Component<Props> {
  render () {
    return (
      <div>
        <PRHeaderTop {...this.props} />
        <PRHeaderBottom model={this.props.model} />
        <FlashMessageList />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/components/pull_request/Header/index.js